<template>
  <div class="overflow-hidden rounded-lg bg-gray-50 border border-gray-200">
    <div class="px-4 py-5 sm:p-6"><slot></slot></div>
  </div>
</template>
